import { render, staticRenderFns } from "./RenderSchema.vue?vue&type=template&id=0182f277&scoped=true"
import script from "./RenderSchema.vue?vue&type=script&lang=js"
export * from "./RenderSchema.vue?vue&type=script&lang=js"
import style0 from "./RenderSchema.vue?vue&type=style&index=0&id=0182f277&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0182f277",
  null
  
)

export default component.exports